// src/portal-app/shell/kit/AvatarRow.js
//
// Overlapping circular avatars. On the Team tab this is the answer to the
// question the tab exists for — "who is working right now" — which five
// faces convey faster than any sentence (spec §5 P2).
//
// The row is aria-hidden: the initials are meaningless to a screen reader,
// and the count is already announced by the LeanHero value beside it.
import React from 'react';
import { ensureKitCss } from './kitCss';
import { toneVar, FALLBACK_TONES } from './tones';

export function AvatarRow({ people, max = 5, size = 30 }) {
    ensureKitCss();
    if (!Array.isArray(people) || people.length === 0) return null;

    const shown = people.slice(0, max);
    const overflow = people.length - shown.length;

    return (
        <div className="pk-av-row" aria-hidden="true">
            {shown.map((p, i) => {
                // Caller-chosen tone wins; otherwise cycle the fallback palette
                // so a row of avatars is never all one colour.
                const token = toneVar(p.tone || FALLBACK_TONES[i % FALLBACK_TONES.length]);
                return (
                    <span
                        key={p.id != null ? p.id : i}
                        className="pk-av"
                        style={{
                            width: size,
                            height: size,
                            background: `var(${token})`,
                            fontSize: Math.round(size * 0.42),
                        }}
                    >
                        {p.initials}
                    </span>
                );
            })}
            {overflow > 0 && (
                <span
                    className="pk-av pk-av-more"
                    style={{ width: size, height: size, fontSize: Math.round(size * 0.36) }}
                >
                    {`+${overflow}`}
                </span>
            )}
        </div>
    );
}

export default AvatarRow;
